<style lang="scss" scoped>
.switch-label {
  font-weight: bold;
  font-size: 0.8rem;
}
</style>

<template>
  <div class="row">
    <div class="col-8">
      <input
        :type="type"
        class="form-control"
        :class="{ 'is-invalid': hasErrors, [colClass]: true }"
        :name="attribute.name"
        :id="attribute.name"
        :value="value"
        @input="$emit('input', $event.target.value)"
        :disabled="switchOn"
      />
      <div
        v-if="attribute.errors !== null"
        v-for="error in attribute.errors"
        :key="error"
        class="invalid-feedback"
      >
        {{ error }}
      </div>
    </div>
    <div class="col-4">
      <toggle-switch
        class="text-md"
        style="font-weight: bold; text-align: right;"
        :class="{ 'is-invalid': hasErrors }"
        type="success"
        label="Standard-Wert"
        v-model="switchOn"
      ></toggle-switch>
    </div>
  </div>
</template>
<script lang="babel">

export default {
  data() {
    return {
      switchOn: this.attribute.switchOn ? this.attribute.switchOn : false,
    }
  },
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    type() {
      return this.attribute.type;
    },
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
  },
  watch: {
    switchOn() {
      if (this.switchOn) {
        this.$emit('input', null);
      }
    },
  }
}
</script>
